import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

const pbase = "/api/admin/TutorialPlaylists";
const vbase = "/api/admin/TutorialVideos";

// ---- Playlist ----
export const getTutorialPlaylistsSaga = createAction(
  "GET_TUTORIAL_PLAYLISTS",
  ({ payload, params }: SagaActionParams<Type.TutorialPlaylistDto[]>) => ({
    payload,
    url: pbase + (params ? params : ""),
  })
);
export const getTutorialPlaylistDetailsSaga = createAction(
  "GET_TUTORIAL_PLAYLIST_DETAILS",
  ({ payload, id }: SagaActionParams<Type.TutorialPlaylistDto>) => ({
    payload,
    url: pbase + "/" + id,
  })
);
export const createTutorialPlaylistSaga = createAction(
  "CREATE_TUTORIAL_PLAYLIST",
  ({ payload, body }: SagaActionParams<Type.TutorialPlaylistDto>) => ({
    payload,
    url: pbase,
    body,
  })
);
export const updateTutorialPlaylistSaga = createAction(
  "UPDATE_TUTORIAL_PLAYLIST",
  ({ payload, id, body }: SagaActionParams<Type.TutorialPlaylistDto>) => ({
    payload,
    url: pbase + "/" + id,
    body,
  })
);
export const deleteTutorialPlaylistSaga = createAction(
  "DELETE_TUTORIAL_PLAYLIST",
  ({ payload, id }: SagaActionParams<Type.TutorialPlaylistDto>) => ({
    payload,
    url: pbase + "/" + id,
  })
);

// ---- Video ----
export const getTutorialVideosSaga = createAction(
  "GET_TUTORIAL_VIDEOS",
  ({ payload, id }: SagaActionParams<Type.TutorialVideoDto[]>) => ({
    payload,
    url: vbase + "/byplaylist/" + id,
  })
);
export const getTutorialVideoDetailsSaga = createAction(
  "GET_TUTORIAL_VIDEO_DETAILS",
  ({ payload, id }: SagaActionParams<Type.TutorialVideoDto>) => ({
    payload,
    url: vbase + "/" + id,
  })
);
export const createTutorialVideoSaga = createAction(
  "CREATE_TUTORIAL_VIDEO",
  ({ payload, body }: SagaActionParams<Type.TutorialVideoDto>) => ({
    payload,
    url: vbase,
    body,
  })
);
export const updateTutorialVideoSaga = createAction(
  "UPDATE_TUTORIAL_VIDEO",
  ({ payload, id, body }: SagaActionParams<Type.TutorialVideoDto>) => ({
    payload,
    url: vbase + "/" + id,
    body,
  })
);
export const deleteTutorialVideoSaga = createAction(
  "DELETE_TUTORIAL_VIDEO",
  ({ payload, id }: SagaActionParams<Type.TutorialVideoDto>) => ({
    payload,
    url: vbase + "/" + id,
  })
);

const tutorialSaga = [
  takeLatest<any>(
    getTutorialPlaylistsSaga.toString(),
    (payload: SagaGenericParams<Type.TutorialPlaylistDto[]>) =>
      getSaga<Type.TutorialPlaylistDto[]>(payload)
  ),
  takeLatest<any>(
    createTutorialPlaylistSaga.toString(),
    (payload: SagaGenericParams<Type.TutorialPlaylistDto>) =>
      postSaga<Type.TutorialPlaylistDto>(payload)
  ),
  takeLatest<any>(
    updateTutorialPlaylistSaga.toString(),
    (payload: SagaGenericParams<Type.TutorialPlaylistDto>) =>
      putSaga<Type.TutorialPlaylistDto>(payload)
  ),
  takeLatest<any>(
    deleteTutorialPlaylistSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.TutorialPlaylistDto>(payload)
  ),
  takeLatest<any>(
    getTutorialPlaylistDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.TutorialPlaylistDto>) =>
      getSaga<Type.TutorialPlaylistDto>(payload)
  ),
  takeLatest<any>(
    getTutorialVideoDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.TutorialVideoDto>) =>
      getSaga<Type.TutorialVideoDto>(payload)
  ),
  takeLatest<any>(
    getTutorialVideosSaga.toString(),
    (payload: SagaGenericParams<Type.TutorialVideoDto[]>) =>
      getSaga<Type.TutorialVideoDto[]>(payload)
  ),
  takeLatest<any>(
    createTutorialVideoSaga.toString(),
    (payload: SagaGenericParams<Type.TutorialVideoDto>) =>
      postSaga<Type.TutorialVideoDto>(payload)
  ),
  takeLatest<any>(
    updateTutorialVideoSaga.toString(),
    (payload: SagaGenericParams<Type.TutorialVideoDto>) =>
      putSaga<Type.TutorialVideoDto>(payload)
  ),
  takeLatest<any>(
    deleteTutorialVideoSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.TutorialVideoDto>(payload)
  ),
];

export default tutorialSaga;
